"use client"
import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";

const IDLE_TIMEOUT = 15 * 60 * 1000;
// const IDLE_TIMEOUT = 0.25 * 60 * 1000;

const ActivityTracker = ({ children }: { children: React.ReactNode }) => {

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const pathname = usePathname();

  const resetTimer = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    };
    if (typeof window !== "undefined") {
      timeoutRef.current = setTimeout(() => {
        console.log("sign out - on activity check")
        localStorage.removeItem("token");
        window.location.href = "/sign-in?status=timed-out";
      }, IDLE_TIMEOUT);
    }
  };

  useEffect(() => {

    if (pathname !== "/sign-in") {
      resetTimer();

      window.addEventListener("keydown", resetTimer);
      window.addEventListener("click", resetTimer);
  
      return () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        window.removeEventListener("keydown", resetTimer);
        window.removeEventListener("click", resetTimer);
      };
    }
  }, [pathname]);

  return <>{children}</>;
};

export {
  ActivityTracker 
};
